export interface Address {
  id: string;
  houseNumber: string;
  street: string;
  place: string;
  postalCode: string;
  cantonCode: string;
  countryISOCode: string;
  fullAddress: string;
}
